import axios from 'axios'
import _ from 'lodash'

export default {
  namespaced: true,

  state: {
    customers: [],
    pagination: {},
    page: 1
  },
  mutations: {
    set(state, customers) {
      state.customers = _.unionBy(state.customers, customers, 'id')
    },
    pagination(state, pagination) {
      state.pagination = pagination
    },
    reset(state) {
      state.customers = []
      state.page = 1
    },
    removeCustomer(state, id) {
      state.customers = state.customers.filter(c => c.id !== id)
    },
    changePage(state, page) {
      if (page) {
        state.page = page
      } else {
        state.page++
      }
    }
  },
  actions: {
    async fetch({commit, getters}, params) {
      const page = getters.page
      try {
        const url = process.env.VUE_APP_BACKEND
        const customers = await axios.get(url + '/customers/search', {
          params: {...params, page, perPage: 24, 'filters[isPublic]': true}
        })
        commit('pagination', customers.data.result[1])
        commit('set', customers.data.result[0])
        commit('changePage')
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      }
    },
    async convertToEnterprise({commit}, id) {
      try {
        const url = process.env.VUE_APP_BACKEND
        const response = await axios.post(url + '/customers/' + id + '/convert-to-enterprise')
        if (response.data.success) {
          commit('removeCustomer', id)
        }
        return response.data
      } catch (e) {
        throw e
      }
    },
    async linkAsEnterprise({commit}, id) {
      try {
        const url = process.env.VUE_APP_BACKEND
        const response = await axios.post(url + '/customers/' + id + '/link-enterprise')
        if (response.data.success) {
          commit('removeCustomer', id)
        }
        return response.data
      } catch (e) {
        throw e
      }
    },
    async unlinkAsEnterprise({commit}, id) {
      try {
        const url = process.env.VUE_APP_BACKEND
        const response = await axios.delete(url + '/customers/' + id + '/link-enterprise')
        return response.data
      } catch (e) {
        throw e
      }
    }
  },
  getters: {
    customers: s => s.customers,
    pagination: s => s.pagination,
    page: s => s.page
  }
}
